import React, { Component } from 'react';
import PropTypes from 'prop-types';

/* Core */
import Modal from '../../core/Modal';
import ShareSend from '../../core/OptionsNews/ShareSend';

/* Utils */
import { sendEmail } from '../../../utils/apiSocial';

import { StyledSendMsg } from './style';

class ModalEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      error: false,
      isSend: false
    };
  }

  onSendHandler = (emailList, msg) => {
    const { closeModal, contentType, baseContentId } = this.props;
    const data = {
      contentId: baseContentId,
      emailToSend: emailList,
      contentType,
      recommendationText: msg
    };

    this.setState({ isLoading: true });

    sendEmail(data)
      .then(() => {
        this.setState({ isSend: true });
        setTimeout(() => {
          this.setState({ isSend: false });
          closeModal();
        }, 2000);
      })
      .catch(() => {
        this.setState({
          error: true
        });
      })
      .finally(() => this.setState({ isLoading: false }));
  };

  render() {
    const { closeModal } = this.props;
    const { isLoading, error, isSend } = this.state;

    return (
      <Modal clickCloseIcon={closeModal}>
        {!isSend ? (
          <ShareSend
            onSend={this.onSendHandler}
            isLoading={isLoading}
            darkTitle
            error={error}
          />
        ) : (
          <StyledSendMsg>Mensaje enviado</StyledSendMsg>
        )}
      </Modal>
    );
  }
}

ModalEmail.propTypes = {
  closeModal: PropTypes.func,
  contentType: PropTypes.string,
  baseContentId: PropTypes.string
};

export default ModalEmail;
